import React from 'react';
import { CHECKOUT_URLS } from '../lib/checkout';
export function FinalCTA() {
  return <section className="bg-navy text-white py-20 px-4" data-id="element-82">
      <div className="max-w-[720px] mx-auto text-center flex flex-col items-center" data-id="element-83">
        <h2 className="text-2xl md:text-3xl font-bold mb-10 leading-tight max-w-[600px]" data-id="element-84">
          El próximo mes podés seguir con tu plata quieta. O podés tomar la
          primera decisión financiera inteligente de tu vida. 💰
        </h2>

        <div className="w-full max-w-[400px] flex flex-col gap-4 mb-8" data-id="element-85">
          <a href={CHECKOUT_URLS.esencial} className="w-full h-[56px] bg-gold text-navy font-bold text-[18px] rounded-xl flex items-center justify-center shadow-[0_4px_14px_0_rgba(186,117,23,0.39)] hover:bg-gold-600 transition-colors" data-id="element-86">
            💰 Quiero El Costo de No Hacer Nada
          </a>
          <a href={CHECKOUT_URLS.profesional} className="w-full h-[56px] bg-transparent border-2 border-white/20 text-white font-bold text-[16px] rounded-xl flex items-center justify-center hover:bg-white/5 transition-colors" data-id="element-87">
            🚀 Quiero el Plan Profesional
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[13px] text-white/60 font-medium" data-id="element-88">
          <span className="flex items-center gap-1" data-id="element-89">✅ Garantía 7 días</span>
          <span data-id="element-90">·</span>
          <span className="flex items-center gap-1" data-id="element-91">🔒 Pago seguro</span>
          <span data-id="element-92">·</span>
          <span className="flex items-center gap-1" data-id="element-93">⚡ Acceso inmediato</span>
        </div>
      </div>
    </section>;
}